import React from "react";

interface ProfileLinkedDetailsProps {}

const ProfileLinkedDetails: React.FC<ProfileLinkedDetailsProps> = () => {
  return <div></div>;
};

export { ProfileLinkedDetails };
